'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _config = require('../const/config');

var _errors = require('../errors');

var _config2 = require('../utils/config');

var _formatting = require('../utils/formatting');

var _list = require('../utils/list');

var _objects = require('../utils/objects');

var _predicate = require('../utils/predicate');

var _transformers = require('../utils/transformers');

var SCOPES = _config.CONFIG_FIELD_NAMES.SCOPES,
    ALIASES = _config.CONFIG_FIELD_NAMES.ALIASES;


var expandData = function expandData(config) {
  var resolveDataAlias = (0, _objects.propFlipped)(config.data.aliases);

  // ---------------------------------------------------------------------------
  // Data Node Items
  // ---------------------------------------------------------------------------

  var expandToken = function expandToken(sourceData) {
    return function (dataNodeItem) {
      var _splitOnColon = (0, _formatting.splitOnColon)(dataNodeItem),
          _splitOnColon2 = _slicedToArray(_splitOnColon, 2),
          prefix = _splitOnColon2[0],
          keyName = _splitOnColon2[1];

      var dataNodeName = (0, _ramda.has)(prefix, sourceData) ? prefix : resolveDataAlias(prefix);
      if ((0, _ramdaAdjunct.isUndefined)(dataNodeName)) {
        var availableKeys = (0, _ramda.without)([SCOPES, ALIASES])((0, _ramda.concat)((0, _ramda.keys)(sourceData), (0, _ramda.keys)(config.data[ALIASES])));
        (0, _errors.throwDataError)((0, _errors.unrecognisedDataPrefixError)(prefix, availableKeys));
      }
      var dataNode = (0, _ramda.prop)(dataNodeName, sourceData);
      if ((0, _ramdaAdjunct.isUndefined)(dataNode)) (0, _errors.throwDataError)((0, _errors.missingDataNodeError)(dataNodeName));

      var resolvedValue = (0, _ramda.prop)(keyName, dataNode);
      if ((0, _ramdaAdjunct.isUndefined)(resolvedValue)) (0, _errors.throwDataError)((0, _errors.missingDataItemKeyError)(dataNodeName, keyName));

      // eslint-disable-next-line no-use-before-define
      return expandDataNodeItem(sourceData)(resolvedValue);
    };
  };

  var expandParts = function expandParts(sourceData) {
    return function (dataNodeItem) {
      return (0, _ramda.pipe)(_formatting.splitOnUnnestedWhitespace,
      // eslint-disable-next-line no-use-before-define
      expandDataNodeItems(sourceData), _formatting.joinWithSpace)(dataNodeItem);
    };
  };

  var expandDataNodeItems = function expandDataNodeItems(sourceData) {
    return function (dataNodeItems) {
      return (
        // eslint-disable-next-line no-use-before-define
        (0, _ramda.map)(expandDataNodeItem(sourceData))(dataNodeItems)
      );
    };
  };

  var expandDataNodeItem = function expandDataNodeItem(sourceData) {
    return function (dataNodeItem) {
      return (0, _ramda.cond)([[_predicate.isToken, expandToken(sourceData)], [_predicate.isCSSFunction, (0, _transformers.transformFunctionElements)(expandDataNodeItems(sourceData))], [_predicate.hasUnnestedWhitespace, expandParts(sourceData)], [_ramda.T, _ramda.identity]])(dataNodeItem);
    };
  };

  // ---------------------------------------------------------------------------
  // Data Nodes
  // ---------------------------------------------------------------------------

  var expandDataNode = function expandDataNode(dataNodeName) {
    var expandedRootDataItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, _list.reduceWithKeys)(function (dataNodeItem, key) {
      var sourceData = (0, _ramda.over)((0, _ramda.lensProp)(dataNodeName), (0, _ramda.mergeDeepLeft)(dataNodeItem), expandedRootDataItem);
      return (0, _ramda.over)((0, _ramda.lensProp)(key), (0, _ramda.when)(_ramdaAdjunct.isString, expandDataNodeItem(sourceData)))(dataNodeItem);
    });
  };

  var expandDataNodes = function expandDataNodes() {
    var expandedRootData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _list.reduceWithKeys)(function (acc, key) {
      return (0, _ramda.pipe)(expandDataNode, (0, _ramda.over)((0, _ramda.lensProp)(key), _ramda.__, acc))(key, expandedRootData);
    });
  };

  // ---------------------------------------------------------------------------
  // Scopes
  // ---------------------------------------------------------------------------

  var expandScopes = function expandScopes(expandedRootData) {
    return (0, _ramda.map)((0, _ramda.over)(_config2.lData, expandDataNodes(expandedRootData)));
  };

  // ---------------------------------------------------------------------------
  // Data
  // ---------------------------------------------------------------------------

  var expandDataImp = function expandDataImp(data) {
    // Expand the default data nodes
    var expandedRootData = (0, _ramda.pipe)((0, _ramda.without)(SCOPES), expandDataNodes(data))(data);
    // Expand the data nodes inside scopes
    var expandedScopeData = (0, _ramda.pipe)(_config2.pScopes, (0, _ramda.when)(_ramdaAdjunct.isNotUndefined, expandScopes(expandedRootData)))(data);

    return (0, _ramda.assoc)(SCOPES, expandedScopeData)(expandedRootData);
  };

  return (0, _ramda.over)(_config2.lData, expandDataImp, config);
};

exports.default = expandData;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/expandData.js
// module id = 643
// module chunks = 168707334958949